import debounce from 'lodash-es/debounce';
import Flickity from 'flickity';

const sliders = [];

const destroySliders = () => {
  sliders.forEach((slider) => {
    slider.destroy();
  });
};

const handleSlider = debounce(() => {
  if (sliders.length > 0) {
    destroySliders();
  }

  document.querySelectorAll('[data-cms-product-slider]').forEach((slider) => {
    const tiles = slider.querySelectorAll('[data-product-tile]');
    const tile_width = tiles[0].offsetWidth;
    const containerWidth = slider.offsetWidth;

    if (tiles.length * tile_width >= containerWidth) {
      const carousel = new Flickity(slider, {
        wrapAround: true,
        dragThreshold: 10,
      });
      sliders.push(carousel);
    }
  });
}, 250);

const initSlider = () => {
  window.addEventListener('resize', handleSlider);
};

export { destroySliders, initSlider };
